export const EVENT_TIME = {
	TIME_DISPLAY_FORMAT: 'MM/DD/YYYY hh:mm A',
	TIME_FORMAT: 'YYYY-MM-DDTHH:mm',
};
